import React from 'react';
import styled from 'styled-components';
import { ExternalLink } from '../../Icons';
import { theme } from '../../../styled';
export const MenuItemWrapper = styled.li `
  list-style: none;
  display: flex;
  height: 100%;
`;
export const Item = styled.a `
  display: flex;
  align-items: center;
  font-size: ${(props) => props.theme.fontXXSmall};
  padding-left: 10px;
  padding-right: 10px;
  color: ${(props) => props.theme.darkGray};

  .external-link-icon {
    margin-left: 10px;
  }

  &:hover {
    color: ${(props) => props.theme.blue};
  }

  &:hover path {
    fill: ${(props) => props.theme.blue};
  }
`;
const MenuItem = ({ item }) => (React.createElement(MenuItemWrapper, null,
    React.createElement(Item, { href: item.url, target: item.target || 'self' },
        item.name,
        React.createElement(ExternalLink, { width: 10, height: 10, color: theme.darkGray }))));
export default MenuItem;
